import { CallApi, handleJSONResponse } from './common';

const callAPI = CallApi('leads/artist');

export const summary = async (artistId: string) => {
  const response = await callAPI(`/${artistId}`, 'GET');

  return await handleJSONResponse(response);
};

export const exportLeads = async (artistId: string) => {
  const response = await callAPI(`/${artistId}/export`, 'GET');

  if (response.ok) {
    const newBlob = new Blob([await response.blob()], { type: 'text/csv' });
    const navigator = window.navigator as any;
    if (navigator && navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(newBlob);
    } else {
      const objUrl = window.URL.createObjectURL(newBlob);
      const today = new Date().toISOString().split('T')[0];

      const link = document.createElement('a');
      link.href = objUrl;
      link.download = `leads_export_${today}.csv`;
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(objUrl);
      }, 250);
    }
  }
};
